module.exports = __webpack_public_path__ + "fonts/HKGrotesk-Medium.c471e9a.otf";